var map = {
	"./building.png": 61,
	"./fit_app.png": 153,
	"./la_maison_jungle.png": 154,
	"./open_shop.png": 155,
	"./react_appointments.png": 156,
	"./todo_list.png": 157,
	"./weather_app.png": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;